import { cn } from 'src/utilities/cn'
import React from 'react'
import RichText from '@/components/RichText'
import { Media as MediaType } from '@/payload-types'
import { CMSLink, CMSLinkType } from '@/components/Link'
import { MediaBlock } from '@/blocks/Media/Component'

type Props = {
  className?: string
  content: Record<string, any>
  media: MediaType
  imageAlignment: 'left' | 'right'
  links: { link: CMSLinkType }[] | null
}

export const RoundedGraphicBlock: React.FC<Props> = ({
  className,
  content,
  media,
  imageAlignment,
  links,
}) => {
  const right = imageAlignment === 'right'
  return (
    <div
      className={cn(
        'container max-w-[1000px] grid grid-cols-1 sm:grid-cols-2 gap-10 items-center justify-items-center py-16',
        className,
      )}
    >
      <MediaBlock
        media={media}
        blockType={'mediaBlock'}
        className={cn('hidden sm:flex max-h-[400px]', right ? 'order-last' : 'order-first')}
      />
      <div className={cn(right ? 'text-right' : '')}>
        <RichText content={content} enableGutter={false} enableProse={false} className={'mb-4'} />
        {Array.isArray(links) &&
          links.length > 0 &&
          links.map(({ link }, i) => {
            return <CMSLink key={i} {...link} />
          })}
      </div>
    </div>
  )
}
